import React from "react";

const ComponentProvider = React.createContext();

export default { ComponentProvider };
